import { styled } from 'styled-components';
import { InputGroup, Label } from '.';

const TextInput = ({ label, name, type = 'text', required = false, placeholder }) => (
  <InputGroup>
    <Label htmlFor={name}>
      {label}
      {required && '*'}
    </Label>
    {type === 'textarea' ? (
      <Textarea
        as='textarea'
        name={name}
        placeholder={placeholder}
        required={required}
      />
    ) : (
      <Input
        name={name}
        type={type}
        placeholder={placeholder}
        required={required}
      />
    )}
  </InputGroup>
);

const Input = styled.input`
  padding: ${props => props.theme.paddingMd};
  font-size: ${props => props.theme.sizeBody};
  letter-spacing: ${props => props.theme.normalSpacing};
  color: ${props => props.theme.textColor};
  background-color: ${props => props.theme.backgroundColor};
  border: none;
  border-radius: ${props => props.theme.borderRadiusMd};
  outline: none;

  &:focus {
    box-shadow: 0 0 0 4px ${props => props.theme.foregroundColor},
      0 0 0 6px ${props => props.theme.brand + props.theme.clear50};
  }
`;

const Textarea = styled(Input)`
  min-height: 8rem;
  resize: none;
`;

export default TextInput;
